/* eslint-disable import/prefer-default-export */
export const accountInitialState = {
  user: {},
  bookings: [],
  purchases: [],
  bookingByUserID: [],
};
